import { Center, Group, type InputProps } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import { type FormFieldProps } from "./FormField";

interface FormFieldRightSectionProps {
  rightSection?: InputProps["rightSection"];
  warned?: FormFieldProps["warned"];
}

function FormFieldRightSection({
  rightSection,
  warned
}: FormFieldRightSectionProps) {
  if (!rightSection && !warned) {
    return null;
  }

  return (
    <Group gap="xs" wrap="nowrap">
      {rightSection}
      {warned && (
        <Center>
          <IconAlertTriangle
            color="var(--mantine-color-warning-filled)"
            size="1.2em"
          />
        </Center>
      )}
    </Group>
  );
}

export { FormFieldRightSection };
